<div class="box--one">
  <div class="text--title">{{ "common.selectSubCategory" | translate }}</div>
  <ng-content></ng-content>
</div>
